import { createSlice } from "@reduxjs/toolkit";
import { reKycPanUtilityThunk } from "./thunk";

export const initialState = {
  reKycPanUtilityData: [],
  reKycPanUtilityError: "",
  reKycPanUtilityLoading: false,
};

const ReKycPanUtility = createSlice({
  name: "ReKycPanUtility",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(reKycPanUtilityThunk.pending, (state) => {
      state.reKycPanUtilityLoading = true;
      state.reKycPanUtilityData = [];
      state.reKycPanUtilityError = "";
    });
    builder.addCase(reKycPanUtilityThunk.fulfilled, (state, action) => {
      state.reKycPanUtilityData = action.payload.data;
      state.reKycPanUtilityLoading = false;
    });
    builder.addCase(reKycPanUtilityThunk.rejected, (state, action) => {
      state.reKycPanUtilityError =
        action?.message || "An unknown error occurred";
      state.reKycPanUtilityData = action?.payload?.data || {};
      state.reKycPanUtilityLoading = false;
    });
  },
});

export const { apiRequest, apiError } = ReKycPanUtility.actions;

export default ReKycPanUtility.reducer;
